import React from 'react';
import { Icon as EmotionIcon } from './Icon-emotion';
import { Icon as CompiledIcon } from './Icon-compiled';
import { AKIconWrapper as EmotionAKIconWrapper } from './Icon-emotion';
import { AKIconWrapper as CompiledAKIconWrapper } from './Icon-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var Icon = function Icon(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledIcon, props) : /*#__PURE__*/React.createElement(EmotionIcon, props);
};
export var AKIconWrapper = function AKIconWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledAKIconWrapper, props) : /*#__PURE__*/React.createElement(EmotionAKIconWrapper, props);
};